import MediaCard from "./MediaCard";

export default function VideoStack({ items, poster = "plain", place = "page" }) {
  const visible = items.filter((item) => {
    if (item.enabled === false || !item.href) return false;
    if (place === "home" && item.home === false) return false;
    if (place === "page" && item.page === false) return false;
    return true;
  });
  if (visible.length === 0) return null;

  return (
    <ul className="mt-6 grid items-stretch gap-6 sm:grid-cols-2">
      {visible.map((item) => (
        <li key={`${item.label}-${item.href}`} className="video-pair min-w-0">
          <a
            className={`gold-chip tone-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            href={item.labelHref || item.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{item.label}</span>
            <span aria-hidden="true">↗</span>
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
          <MediaCard
            href={item.href}
            image={item.image}
            kicker={item.label}
            title={item.title}
            action={item.action}
            poster={item.poster || poster}
            video={item.video !== false}
          />
        </li>
      ))}
    </ul>
  );
}
